module.exports = __webpack_public_path__ + "jetbov.png?17b34380dbbdb5e2f59d8fa5dcd1ec58";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jetbov.png
// module id = 25
// module chunks = 0